import { render, staticRenderFns } from "./DocumentoRemolque.vue?vue&type=template&id=c9ed5916"
import script from "./DocumentoRemolque.vue?vue&type=script&lang=js"
export * from "./DocumentoRemolque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports